import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import styles from './hera-page-about.module.css';
import { Container, Htag, HtagVariant, Paragraph } from '../../components';

export default function HeraPageAbout() {
  return (
    <section className={styles.aboutProject}>
      <Container>
        <div className={styles.aboutProject_inner}>
          <div className={styles.aboutProject_start}>
            <Htag
              tag="h3"
              className={styles.aboutProject_title}
              variant={HtagVariant.h3}
            >
              ABOUT THE PROJECT
            </Htag>
            <Paragraph>
              Wait for the big day with this Hera app. Choose your due date, set
              your own pregnancy goals and health info, and get the weekly
              information about your pregnancy and baby development progresses.
              Play with 3D model of your baby every week; browse more than 1,000
              pregnancy articles and useful tips; follow the specialised
              workouts for pregnant women, yoga and stretching; cook healthy
              recipes and enjoy this special period.
            </Paragraph>
          </div>
          <div className={styles.aboutProject_end}>
            <Player
              className={styles.aboutProject_lottie}
              src="https://assets1.lottiefiles.com/private_files/lf30_xku2faxz.json"
              background="transparent"
              speed={1}
              loop
              autoplay
            />
          </div>
        </div>
      </Container>
    </section>
  );
}
